<app-header></app-header>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="activation-page">
          <div>
            <img src="assets/images/verification-img.png" />
            <form class="activation-form">
              <div class="form-group">
                <h1 class="mb-3">
                  {{ "ACTIVATION.VERIFICATION_TEXT" | translate }}
                </h1>
                <p class="text-secondary mb-4">
                  Please enter activation code to authenticate your account and link to TV app.
                </p>
                <ng-otp-input
                  (onInputChange)="onOtpChange($event)"
                  [config]="{ length: 6 }"
                >
                </ng-otp-input>
                <!-- <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="msgContent.errors && textForm.submitted"
                >
                  <p class="mb-0" *ngIf="msgContent.errors.required">
                    please enter code
                  </p>
                </div> -->
              </div>
              <div>
                <button
                  [ngClass]="{ disabled: !btnDisable }"
                  class="btn btn-theme"
                  (click)="submit()"
                >
                  {{ "ACTIVATION.SUBMIT" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
